/* eslint-disable no-console */
import onDOMReady from '../js/utils/onDomReady';
// import './prevent-script-injections';
import './member-join-form';
import './dependant/form-dependant';
import './dependant/form-dependant-item';
import './total-allocation/form-total-allocation';

onDOMReady(() => {
    if (document.querySelector('.form-step-count')) {
        import('./step-count/form-step-count').then(() => {
            console.info('Loaded JS: ./step-count/form-step-count');
        });
    }
    if (document.querySelector('.datepicker-pikaday')) {
        import('./datepicker/form-datepicker').then(() => {
            console.info('Loaded JS: ./datepicker/form-datepicker');
        });
    }
    if (document.querySelector('.file-uploader-wrapper')) {
        import('./file-uploader/form-file-uploader').then(() => {
            console.info('Loaded JS: ./file-uploader/form-file-uploader');
        });
    }
    if (document.querySelector('div[data-toggle-form-section], select[data-toggle-form-section], input[data-toggle]')) {
        import('./toggle-group/form-toggle-group').then(() => {
            console.info('Loaded JS: ./toggle-group/form-toggle-group');
        });
    }
    if (document.querySelector('form.form-layout, .address-search, .address-search, #DaytimeTelephone, #Mobile')) {
        import('./forms-validation').then(() => {
            console.info('Loaded JS: ./forms-validation');
        });
    }
    if (document.querySelector('select.form-control, .ktc-form-section-title, input[data-val-number], input[type="checkbox"].customCheckbox, input[value="other"]')) {
        import('./dancing-goat-form').then(() => {
            console.info('Loaded JS: ./dancing-goat-form');
        });
    }
    // if (document.querySelector('[title], .tfn, select.category, input[class$="opt"], [class*="-address-search"], .ktc-form-section-title, [class*="mobilenumber"], [class*="maxlength"], [data-toggle-val*="maxlength"], [class*="minlength"], input[type="submit"], .explanation-text, .ktc-checkbox, input[data-rule-tfn="true"], input[data-rule-format="true"], [data-toggle*="autofocus"], .form-field input, .form-field select, .email-confirm, [data-toggle-val="number"], [class*="number"], [class*="postcode"], input[type="email"], [data-toggle="autofilldisable"], [data-toggle-val="column"]')) {
    //     import('./member-join-form').then(() => {
    //         console.info('Loaded JS: ./member-join-form');
    //     });
    // }
    // if (document.querySelector('.form-dependant, [data-toggle="beneficiary"]')) {
    //     import('./dependant/form-dependant').then(() => {
    //         console.info('Loaded JS: ./dependant/form-dependant');
    //     });
    // }
    // if (document.querySelector('.form-dependant-item')) {
    //     import('./dependant/form-dependant-item').then(() => {
    //         console.info('Loaded JS: ./dependant/form-dependant-item');
    //     });
    // }
    // if (document.querySelector('.form-total-allocation, [title*="form-total-allocation"]')) {
    //     import('./total-allocation/form-total-allocation').then(() => {
    //         console.info('Loaded JS: ./total-allocation/form-total-allocation');
    //     });
    // }
});
